import { $, $$ } from './utils';

document.addEventListener('DOMContentLoaded', () => {
    const cityButton = $('#city_button');
    const cityDropdown = $('#city_dropdown');
    const citySearch = $('#city_search');
    const mbiButton = $('#menu_bar_items_button');
    const mbiDropdown = $('#menu_bar_items_dropdown');

    const toggleCityDropdown = (e) => {
        e.stopPropagation();
        if (isDropDownActive(cityDropdown)) {
            cityDropdown.classList.add('fade-out');
            cityDropdown.classList.remove('fade-in');
            cityButton.classList.remove('is-active');
        } else {
            cityDropdown.classList.add('fade-in');
            cityDropdown.classList.remove('fade-out');
            cityButton.classList.add('is-active');
        }

        closeMbiDropdown();
        closeCountryDropdown();
    };

    if (cityButton && citySearch) {
        cityButton.addEventListener('click', (e) => {
            toggleCityDropdown(e);
        });
        cityButton.addEventListener('keydown', function (e) {
            if (e.key === ' ') {
                toggleCityDropdown(e);
                e.preventDefault();
                if (isDropDownActive(cityDropdown)) {
                    setFocusTo('#city_search');
                    loopFocusOn('.header_nav__options a');
                }
            }
        });

        cityDropdown.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        citySearch.addEventListener('input', (e) => {
            let filterValue = e.target.value.toLowerCase();
            let cities = cityDropdown.getElementsByTagName('a');
            let city;
            for (let i = 0; i < cities.length; i++) {
                city = cities[i].innerText;
                if (city.toLowerCase().indexOf(filterValue) > -1) {
                    cities[i].style.display = '';
                } else {
                    cities[i].style.display = 'none';
                }
            }
        });
    }

    const toggleCountryDropdown = () => {
        closeCityDropdown();
        closeMbiDropdown();
    };

    document.addEventListener('countryButtonClicked', (e) => {
        if (e.detail.withKeyboard && e.detail.isOpen) {
            setFocusTo('#country_dropdown a');
            loopFocusOn('#country_dropdown a');
        }
        toggleCountryDropdown();
    });

    document.addEventListener('languageButtonClicked', (e) => {
        if (e.detail.withKeyboard && e.detail.isOpen) {
            setFocusTo('#language_dropdown a');
            loopFocusOn('#language_dropdown a');
        }
        closeCityDropdown();
        closeMbiDropdown();
    });

    const toggleMenuBarItems = (e) => {
        e.stopPropagation();
        if (isDropDownActive(mbiDropdown)) {
            mbiDropdown.classList.add('fade-out');
            mbiDropdown.classList.remove('fade-in');
            mbiButton.classList.remove('is-active');
        } else {
            mbiDropdown.classList.add('fade-in');
            mbiDropdown.classList.remove('fade-out');
            mbiButton.classList.add('is-active');
        }
        closeCityDropdown();
        closeCountryDropdown();
    };

    if (mbiButton && mbiDropdown) {
        mbiButton.addEventListener('click', (e) => {
            toggleMenuBarItems(e);
        });
        mbiButton.addEventListener('keydown', (e) => {
            if (e.key === ' ') {
                toggleMenuBarItems(e);
                e.preventDefault();
                if (isDropDownActive(mbiDropdown)) {
                    setFocusTo('#menu_bar_items_dropdown a');
                    loopFocusOn('#menu_bar_items_dropdown a');
                }
            }
        });
    }

    $('main').addEventListener('click', () => {
        closeAllDropdowns();
    });

    const links = $$('[data-scroll]');
    links.forEach((link) => {
        link.addEventListener(
            'click',
            (e) => {
                e.preventDefault();
                const href = e.target.getAttribute('data-scroll');
                const target = $(href);

                if (!target) {
                    return; // exit if no target found (e.g. not found page also has menu)
                }

                const rect = target.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                scroll({
                    top: rect.top + scrollTop,
                    behavior: 'smooth',
                });
            },
            false,
        );
    });

    function closeCityDropdown() {
        if (cityDropdown && cityButton) {
            cityDropdown.classList.remove('fade-in');
            cityDropdown.classList.add('fade-out');
            cityButton.classList.remove('is-active');
        }
    }

    function closeCountryDropdown() {
        const event = new CustomEvent('closeCountryDropdown');
        document.dispatchEvent(event);
    }

    function closeMbiDropdown() {
        if (mbiButton && mbiDropdown) {
            mbiDropdown.classList.remove('fade-in');
            mbiDropdown.classList.add('fade-out');
            mbiButton.classList.remove('is-active');
        }
    }

    function closeAllDropdowns() {
        closeCityDropdown();
        closeCountryDropdown();
        closeMbiDropdown();
    }

    function isDropDownActive(element) {
        return element.classList.contains('fade-in');
    }

    function setFocusTo(selector) {
        const element = $(selector);
        if (element) {
            setTimeout(() => element.focus(), 300);
        }
    }

    function loopFocusOn(selector) {
        const elements = $$(selector);
        if (elements && elements.length > 1) {
            const firstElement = elements[0];
            const lastElement = elements[elements.length - 1];

            // Add event listener to the last element to loop focus back to the first
            lastElement.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    firstElement.focus();
                }
            });
        }
    }
});
